import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName'
})
export class FullNamePipe implements PipeTransform {
  transform(firstName: string, surname: string): string {
    if (!firstName && !surname) {
      return '';
    }

    const first = firstName || '';
    const last = surname || '';

    return `${first} ${last}`.trim();
  }
}
